import { useShallow } from 'zustand/react/shallow';
import { useReceiptBatchStore } from './ReceiptBatchContext';

/**
 * Returns the payment processor of the currently selected nursing home
 * in the receipt batch form. Defaults to 'stripe' when no nursing home
 * is selected or when the lookup fails.
 */
export function useSelectedNursingHomePaymentProcessor():
  | 'stripe'
  | 'mangopay' {
  return useReceiptBatchStore(
    useShallow((state) => {
      const nursingHomeId = state.formik?.values?.nursingHomeId;
      const nursingHome = state.nursingHomes?.find(
        (n) => n.nursingHomeId === nursingHomeId
      );
      return nursingHome?.paymentProcessor ?? 'stripe';
    })
  );
}
